import React, { PropsWithChildren } from "react";
import { Button, Modal } from "react-bootstrap";

interface Props {
    show: boolean,
    title: string,
    onClose: () => void
}

const AssetModal = ({ children, show, title, onClose }: PropsWithChildren<Props>) => { 
    return (
      <>
        <Modal show={show} onHide={onClose} size="lg">
          <Modal.Header closeButton className="px-3 py-2">
            <h2 className="text-xl m-0">{title}</h2>
          </Modal.Header>
          <Modal.Body>
              {children}
          </Modal.Body>
          {/*<Modal.Footer>
            <Button variant="secondary" size="sm" onClick={onClose}>
              Close
            </Button>
          </Modal.Footer>*/}
        </Modal>
      </>
    );
  }

  export default AssetModal;
  